import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import nodeinstance from "../../../../nodeInstance";
// import axios from "axios";
import { axios } from "../../../../Global";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { priority_of_issuance } from "../../../../constant";
import { getVisaRequestData } from "../../../../store/Api";
import { sortByName } from "../../../../utils/sortByName";

export default function EditvisaRequest({ propId, setAddOrEdit }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const token = localStorage.getItem("nodeToken");
  const laravelToken = localStorage.getItem("token");
  const [sponserId, setSponsorId] = useState();

  const validationSchema = Yup.object().shape({
    sponsor_id: Yup.string(),
    nationality_id: Yup.string(),
    visa_stamp_city: Yup.string(),
    visa_profession_id: Yup.string(),
    gender: Yup.string(),
    priority_of_issuance: Yup.string(),
    total_visa: Yup.string(),
    visa_service_charge: Yup.string(),
    payment_terms_for_visa: Yup.string(),
    payment_terms_for_post_arrival: Yup.string(),
    company_id: Yup.string(),
  });
  const {
    register,
    control,
    watch,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA REQUEST FORM SUMMARY",
          link: "/dashboard/visa-request-form",
        },
        {
          label: "OPS 1 DESK SUMMARY",
          link: "/dashboard/visa-request-form/ops-1-summary",
        },
        {
          label: "EDIT VISA REQUEST FORM",
          // link: `/dashboard/project/${projectDetails?.id}`,
        },
      ])
    );
  }, [location]);
  const [fieldDropdownData, setFieldDropdowndata] = useState();
  const response = async () => {
    try {
      const data = await nodeinstance.get("/dashboard/vrf-visa/visa-details", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (data.status === 200) {
        const payload = data.data;
        if (payload?.data?.Nationalitydata) {
          payload.data.Nationalitydata = sortByName(payload.data.Nationalitydata);
        }
        if (payload?.data?.visaprofession) {
          payload.data.visaprofession = sortByName(payload.data.visaprofession);
        }
        setFieldDropdowndata(payload);
      }
    } catch (error) {
      //   alert("error");
      console.log("error to be displayed here.....", error);
    }
  };
  const [visaProvider, setVisaProvider] = useState();
  const visa_provider = async () => {
    const response = await axios.get("dashboard/company", {
      headers: {
        Authorization: `Bearer ${laravelToken}`,
      },
    });
    if (response.status === 200) {
      console.log(
        "res?.data?.data?.visa_profession",
        response?.data?.data?.company
      );
      setVisaProvider(sortByName(response?.data?.data?.company));  setVisaProvider(sortByName(response?.data?.data?.company));
    }
  };
  const genderDropdown = [
    {
      id: 1,
      Gender: "MALE",
    },
    {
      id: 2,
      Gender: "FEMALE",
    },
  ];
  const priorityIssurence = priority_of_issuance;

  const [genderData, setGenderData] = useState();
  const [ajeerData, setAjeerData] = useState();
  const handlegenderChange = (event) => {
    console.log("event to be triggred", event.target.value);
    setGenderData(event.target.value);
  };
  const navigate = useNavigate();

  const [visaData, setVisaData] = useState();
  const handleVisaChange = async (event) => {
    // console.log("event visa", JSON.parse(event.target.value));
    console.log("dgcgdgygydgcytgty", event.target.value);
    setVisaData(event.target.value);
    let reqObject = {
      company_id: event.target.value,
    };
    const response = await nodeinstance.post(
      `/dashboard/vrf-visa/getvisaproviderbyId`,
      reqObject,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status === 200) {
      console.log("data to be printed here.........", response);
      setSponsorId(response.data.data?.sponsor_id);
    }
  };
  const [nationality, setNationality] = useState("");
  const handleNationalityChange = (event) => {
    console.log("event", event.target.value);
    setNationality(event.target.value);
  };
  const [visaprofession, setVisaprofession] = useState();
  const handleVisaprofessionChange = (event) => {
    setVisaprofession(event.target.value);
  };

  useEffect(() => {
    response();
    visa_provider();
  }, []);

  const formRef = useRef(null);

  const formChange = (event) => {
    let formDetails = getValues();
  };

  const oncancelClick = () => {
    navigate("/dashboard/visa-request-form/ops-1-summary");
    setAddOrEdit((p) => ({ ...p, routeName: "" }));
  };

  const [vrfData, setVrfData] = useState();

  const editDate = async (propId) => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/vrf-visa/getVrfVisaDetails/${propId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("Data to be printed here VRF DATA.....", response);
        setVrfData(response.data.data);
      }
    } catch (error) {
      console.log("error.......", error);
    }
  };
  console.log("Data to be printed here VRF DATA.....", vrfData);

  useEffect(() => {
    editDate(propId);
  }, [propId]);

  useEffect(() => {
    const data = vrfData?.map((data, i) => {
      setValue("company_id", data.company_id);
      setValue("sponsor_id", data.sponsor_id);
      setSponsorId(data.sponsor_id);
      setVisaprofession(data.visa_profession_id);
      setNationality(data.nationality_id);
      setGenderData(data.gender);
      setValue("visa_stamp_city", data.visa_stamp_city);
      setValue("priority_of_issuance", data.priority_of_issuance);
      setValue("total_visa", data?.total_visa);
      setValue("visa_service_charge", data?.visa_service_charge);
      setAjeerData(data?.ajeer);
      setValue("payment_terms_for_visa", data?.payment_terms_for_visa);
      setValue(
        "payment_terms_for_post_arrival",
        data?.payment_terms_for_post_arrival
      );
      setVisaData(data.company_id);
    });
  }, [vrfData]);

  console.log("visaData.......", visaData);

  const onSubmit = async (data) => {
    const reqObject = {
      ...data,
      sponsor_id: sponserId,
      ajeer: ajeerData,
      gender: genderData,
      nationality_id: nationality,
      visa_profession_id: visaprofession,
      status: "DRAFT VRF CREATED",
    };
    if (data.total_visa <= 0) {
      dispatch(
        setAppError({
          msg: "Count must be greater than 0",
        })
      );
      return;
    }
    console.log("yrguyuygygyggyggcfgygyug", reqObject);
    const response = await nodeinstance.put(
      `/dashboard/vrf-visa/updateVrfDetails/${propId}`,
      reqObject,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      navigate("/dashboard/visa-request-form/ops-1-summary");
      setAddOrEdit((p) => ({ ...p, routeName: "" }));
      dispatch(getVisaRequestData(token));
      dispatch(
        setAppError({
          msg: "Updated Successfully..",
          color: "success",
        })
      );
    }
    console.log("data to be displayed here.....", reqObject);
  };

  return (
    <form
      onChange={formChange}
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
    >
      <div className="flex flex-col justify-center items-center bg-white dark:bg-dark rounded-md py-5">
        <h2 className="text-xl font-semibold">EDIT VRF</h2>
        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor="" className="px-1">
            VISA PROVIDER
          </label>
          <select
            {...register("company_id")}
            className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            onChange={handleVisaChange}
            value={visaData}
          >
            <option>{"select value"}</option>
            {visaProvider?.map((data, index) => (
              <React.Fragment key={index}>
                <option value={data.company_id}>{data.name}</option>
              </React.Fragment>
            ))}
          </select>
        </div>

        <div className="flex flex-col p-2 gap-1 w-full max-w-md">
          <label htmlFor={`addOrEdit-name`} className="text-xs">
            AJEER
          </label>

          <div className="flex gap-10">
            <label className="flex items-center">
              <input
                type="radio"
                name="ajeerOption"
                value={ajeerData ? ajeerData : "YES"}
                onChange={(event) => {
                  setAjeerData(event.target.value);
                }}
              />
              <span>YES</span>
            </label>

            <label className="flex items-center">
              <input
                type="radio"
                name="ajeerOption"
                // value="NO"
                value={ajeerData ? ajeerData : "NO"}
                onChange={(event) => {
                  setAjeerData(event.target.value);
                }}
              />
              <span>NO</span>
            </label>
          </div>

          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              DATE
            </label>
            <input
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // defaultValue={currentDate}
              value={new Date(vrfData && vrfData[0].created_at)
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                .split(" ")
                .join("-")
                .toUpperCase()}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md border-3 border-green-500 dark:bg-green">
            <label
              htmlFor={`addOrEdit-name`}
              className="text-xs text-green-500"
            >
              SPONSOR ID
            </label>
            <input
              type="text"
              className="border border-red-500 dark:border-dark rounded-md p-1 py-2 text-green-300"
              value={sponserId ? sponserId : ""}
              disabled
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              NATIONALITY
            </label>
            <select
              {...register("nationality_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={nationality}
              onChange={handleNationalityChange}
            >
              <option>{"select value"}</option>
              {fieldDropdownData?.data?.Nationalitydata?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA STAMP CITY
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("visa_stamp_city")}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA PROFESSION
            </label>
            <select
              {...register("visa_profession_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={visaprofession}
              onChange={handleVisaprofessionChange}
            >
              <option>{"select value"}</option>
              {fieldDropdownData?.data?.visaprofession?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs">
              GENDER
            </label>
            <select
              {...register("gender")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={genderData}
              onChange={handlegenderChange}
            >
              <option value="">{"SELECT GENDER"}</option>
              {genderDropdown.map((data, index) => (
                <option key={index} value={data.Gender}>
                  {data.Gender}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PRIORITY OF ISSUANCE
            </label>
            <select
              {...register("priority_of_issuance")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            >
              <option value="">{"SELECT VALUE"}</option>
              {priorityIssurence.map((data, index) => (
                <option key={index} value={data.name}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              TOTAL VISAS
            </label>
            <input
              type="number"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("total_visa")}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA SERVICE CHARGE (SAR)
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("visa_service_charge")}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PAYMENT TERMS FOR VISA
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("payment_terms_for_visa")}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              PAYMENT TERMS FOR POST ARRIVAL
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              {...register("payment_terms_for_post_arrival")}
            />
          </div>
          <div className="p-2  w-full max-w-md flex gap-3">
            <button
              className="w-full ring-1 rounded-md text-xs ring-black"
              onClick={() => oncancelClick()}
            >
              Cancel
            </button>
            <button
              className="bg-black dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
            >
              <p>Submit</p>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
